import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

export async function getUserIdentificationList(params: any) {
    const GET_USER_IDENTIFICATION = gql`
    query getUserIdentificaions($where: UserIdentificationLinkExcelWhereInput, $orderBy: [UserIdentificationLinkExcelOrderByInput!]){
        UserIdentificationLinkExcels(where: $where, orderBy: $orderBy){
            utmCampaign
            utmSource
            utmMedium
          createdAt    
          id
          outputFileName
          outputFilePath
          service
          status
          updatedAt
          uploadedFileName
          uploadedFilePath  
          updatedBy
        }
        _UserIdentificationLinkExcelsMeta(where: $where){
          count
        }
      }
    `;
    let filterData = deleteNullPropertyValueDiscountFilter(params.filter) 
    console.log('filterData: ', filterData);
    return client.query({
        query: GET_USER_IDENTIFICATION,
        variables: {
            where: { ...filterData },
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
            orderBy: {updatedAt: "Desc"},
        }
    })
}

export async function createUserIdentification(params: any) {

    console.log('createUserIdentification params: ', params);
    let myFormData = new FormData()
    myFormData.append('file', params.data.attachment.rawFile)
    myFormData.append('service', "LIMOOME_SHOP")
    myFormData.append('utmCampaign', params.data.utmCampaign)
    myFormData.append('utmMedium', params.data.utmMedium)
    myFormData.append('utmSource', params.data.utmSource)
    myFormData.append('expirationDate', params.data.expirationDate)
    myFormData.append('targetPageAddress', params.data.targetPageAddress)
    return axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/userIdentificationLinkExcels`,
        data: myFormData,
        method: 'POST',
    })
}

export async function getUserIdentification(params: any) {
    const GET_USER_IDENTIFICATION = gql`
    {
        UserIdentificationLinkExcel(where: {id: ${params.id}}){
            id
            utmCampaign
            utmSource
            utmMedium
            expirationDate
            service
            targetPageAddress
        }
      }
    `;
    return client.query({
        query: GET_USER_IDENTIFICATION
    })
}

export function updateUserIdentification(params: any){
    const {id, ...data} = params;
    let newData = {...data, expirationDate: data.expirationDate ? new Date(data.expirationDate).toISOString() : null}    

    const UPDATE_USER_IDENTIFICATION = gql`
    mutation UpdateUserIdentification($where: UserIdentificationLinkExcelWhereUniqueInput!, $data: UserIdentificationLinkExcelUpdateInput!) {
        updateUserIdentificationLinkExcel(where: $where, data: $data) {
          id
          utmCampaign
          utmMedium
          utmSource
          expirationDate
          service
          targetPageAddress
        }
      }
    `;
    return client.query({
        query: UPDATE_USER_IDENTIFICATION,
        variables: {
            where: {id: id},
            data: {...newData}
        }
    })
}

export const deleteNullPropertyValueDiscountFilter = (filter: any) => {
    let filterData = { ...filter }
    if (!filterData.campaign.contains)
        delete filterData.campaign
    return filterData
}